import { getUserEmail } from "./user";

const firstNames = [
    'John', 'Jane', 'Alex', 'Emily', 'Chris', 'Katie', 
    'Michael', 'Sarah', 'David', 'Laura', 'Robert', 'Emma'
];

const lastNames = [
    "Apple",
    "Banana",
    "Cherry",
    "Date",
    "Elderberry",
    "Fig",
    "Grape",
    "Honeydew"
];

export function isDemoUser(user: any, tenant?: any) {
    if (tenant === "public") {
        return true;
    } else if (user) {
        return getUserEmail(user) === "demo@example.com";
    } else {
        return false;
    }
}

class SeededRandom {
    private seed: number;

    constructor(seed: number) {
        this.seed = seed;
    }

    private lcg(): number {
        // Constants for the LCG
        const a = 1664525;
        const c = 1013904223;
        const m = 2 ** 32;

        this.seed = (a * this.seed + c) % m;
        return this.seed / m;
    }

    public randomInRange(min: number, max: number): number {
        return Math.round(min + this.lcg() * (max - min));
    }
}

export function sanitizeIfDemoUser(user: any, value: any, type: string = "Default") {
    if (isDemoUser(user)) {
        
        const sr = new SeededRandom(value);
        if (type === "CSN") {
            if ((typeof value === 'string' || value instanceof String) && value.startsWith("VISIT")) {
                return value;
            }
            return sr.randomInRange(1000000, 2000000) + "DEMO"
        } else if (type === "MRN") {
            if ((typeof value === 'string' || value instanceof String) && value.startsWith("PATIENT")) {
                return value;
            }
            return sr.randomInRange(80000, 90000) + "DEMO"
        } else if (type === "Age") {
            return sr.randomInRange(18, 90)
        } else {
            return "*".repeat(String(value).length);
        }
    } else {
        return value;
    }
}

export function getRandomElement<T>(array: T[]): T {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}

export function getRandomFirstName() {
    return getRandomElement(firstNames);
}

export function getRandomLastName() {
    return getRandomElement(lastNames);
}

/**
 * Gets the second-level date format from a Date object
 * @param d The date object as a string or epoch timestamp in milliseconds
 * @return e.g. 12/19/2012, 7:00:00 PM
 */
export function getSecondDateStrFromDateStr(d: string | number): string {
    // 2011-10-05T14:48:00.000Z
    const isoDate = new Date(d).toLocaleString("en-US")
    return isoDate
}
